import { axios } from "..";

export const sendPassword = async (
  userName: string,
  userEmail: string,
  userId: string,
) => {
  try {
    const response = await axios.Post(`/password?sendPassword=true`, {
      userName,
      userEmail,
      userId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updatePassword = async (
  password: string,
  confirmPassword: string,
  userName: string,
  code: string,
  firstTime: boolean,
) => {
  try {
    let response;
    if (firstTime) {
      response = await axios.Post("./password?firstTime=true", {
        userName,
        password,
        confirmPassword,
        code,
      });
    } else {
      response = await axios.Post("./password", {
        userName,
        verificationCode: code,
        password,
        confirmPassword,
      });
    }
    return response;
  } catch (error) {
    throw error;
  }
};
